/* ============================================
   Contact Form - Inject placeholders automáticamente
   ============================================
   Hulk Form Builder en versión gratuita no permite placeholders.
   Este script toma el texto de cada label y lo usa como placeholder
   del input asociado.

   Ventajas:
   - Funciona con cualquier cantidad de campos
   - Si el cliente agrega/renombra campos en Hulk, funciona solo
   - No requiere mantenimiento
   ============================================ */

   /* ============================================
   Contact Form - Inyectar placeholders desde labels
   Ajustado al markup (formElement_N) y al CSS (placeholder 26px)
   ============================================ */

(function () {
  function setPlaceholders() {
    const forms = document.querySelectorAll('[class*="hulk_form_"]');
    if (forms.length === 0) return false;

    let applied = 0;

    forms.forEach(function (form) {
      const fields = form.querySelectorAll('[class*="formElement_"]');

      fields.forEach(function (field) {
        // La label de texto del campo (oculta por CSS con .fitText, pero legible)
        const label = field.querySelector('label.fitText, label.block_label, label');
        if (!label) return;

        const labelText = label.textContent
          .replace(/\*/g, '')
          .replace(/\s+/g, ' ')
          .trim();
        if (!labelText) return;

        // Inputs/textarea del campo. El <select> de país queda fuera solo.
        const inputs = field.querySelectorAll('input, textarea');

        inputs.forEach(function (input) {
          const skipTypes = ['hidden', 'submit', 'button', 'reset', 'checkbox', 'radio'];
          if (skipTypes.indexOf(input.type) !== -1) return;
          if (input.getAttribute('placeholder')) return;

          input.setAttribute('placeholder', labelText);
          input.setAttribute('aria-label', labelText);
          applied++;
        });
      });
    });

    return applied > 0;
  }

  function tryApply(attempts) {
    if (setPlaceholders()) return;
    if (attempts <= 0) return;
    setTimeout(function () { tryApply(attempts - 1); }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { tryApply(15); });
  } else {
    tryApply(15);
  }
})();